// src/store/slices/coursesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constant/apiUrl";

export const fetchCourses = createAsyncThunk(
  "courses/fetchCourses",
  async ({ page = 1} = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
            const state = thunkAPI.getState(); // Access Redux state

      const token = state.auth.userArray.access_token; // Assuming token is stored in auth slice

      // أضف كل القيم التي لها قيمة حقيقية فقط


      const response = await axios.get(
        `${apiUrl}/courses`,
          {
          headers: token ? { Authorization: `Bearer ${token}` } : {}, // Add token only if exists
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
// إضافة عقار جديد مع التوكن
export const addcourses = createAsyncThunk(
  "courses/addCourses",
async (formData, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const token = state.auth;
console.log(token,"token");

    // const formData = new FormData();
    // formData.append("title", title);
    // formData.append("description", description);

    // // Append each image
    // image.forEach((image, index) => {
    //   formData.append(`images[${index}]`, image.file); // send the actual File object
    // });


const response = await axios.post(
      "https://nanosoft.technology/blue-nile/api/courses",formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    thunkAPI.dispatch(fetchCourses());
    return response.data;
  } catch (error) {
          console.log(error);

    return thunkAPI.rejectWithValue(      
      error.response?.data?.errors
        ? Object.values(error.response.data.errors)[0][0]
        : "حدث خطأ أثناء إضافة العقار"
    );
  }
}

);
const coursesSlice = createSlice({
  name: "courses",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCourses.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCourses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
                      .addCase(addcourses.pending, (state) => {
                state.loading = true;
                state.error = null;
              })
              .addCase(addcourses.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
              })
              .addCase(addcourses.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
              })
  },
});

export default coursesSlice.reducer;
